/*eslint-disable */
<template>
  <div class="calendar-page-content p-0">
    <div class="row g-4">
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-8">
        <div class="card border-0 shadow-sm rounded-lg">
          <div class="card-header bg-white border-0 p-4">
            <div class="d-flex flex-wrap justify-content-between align-items-center gap-3">
              <h4 class="fw-bold mb-1">Book Appointment</h4>

              <div class="row align-items-center w-100">
                <div class="col-12 col-sm-4 mb-2">
                    <select
                      v-model="selectedCategory"
                      class="form-control form-control-sm border-primary"
                    >
                      <option value="">Choose Category</option>
                      <option value="General">General</option>
                      <option
                        v-for="(category, index) in spcmCalendarCategory"
                        :key="index"
                        :value="category.category_name"
                      >
                        {{ category.category_name }}
                      </option>
                    </select>
                </div>

                <div class="col-12 col-sm-6 col-md-4 col-lg-4 mb-2">
                  <select v-model="viewMonth" class="form-control form-control-sm border-primary" @change="updateCalendarView">
                    <option v-for="month in months" :key="month.value" :value="month.value">{{ month.text }}</option>
                  </select>
                </div>

                <div class="col-12 col-sm-6 col-md-4 col-lg-4 mb-2">
                  <select v-model="viewYear" class="form-control form-control-sm border-primary" @change="updateCalendarView">
                    <option v-for="year in years" :key="year.value" :value="year.value">{{ year.text }}</option>
                  </select>
                </div>

                <div class="col-6 col-sm-6 col-md-4 col-lg-4 mb-2" v-if="userData.user_role === 'USERROLE11118' || userData.user_role === 'USERROLE11111'">
                  <b-button class="w-100" style="border-radius: 7px;" variant="primary" size="sm" @click="addCalendarAppointment()">
                    Add Appointment
                  </b-button>
                </div>

                <div class="col-6 col-sm-3 col-md-2 col-lg-3 mb-2">
                  <b-button class="w-100" style="border-radius: 7px;" variant="primary" size="sm" @click="resetToToday">Today</b-button>
                </div>
              </div>
            </div>
          </div>

          <div class="card-body px-4 pb-4">
            <FullCalendarWrapper :key="allEvents.length" ref="calendarRef" :events="filteredCalendarEvents" @dateSelected="handleDateChange" />
          </div>
        </div>
      </div>

      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-4">
        <div class="card border-0 shadow-sm rounded-lg mb-4">
          <div class="card-header bg-white border-0 p-4 pb-0">
            <h5 class="fw-bold mb-0">{{ isTodaySelected ? `Today` : displayDateLabel }}</h5>
          </div>
          <div class="card-body px-4 pt-3">
            <div v-if="filteredTasks.length > 0" class="task-list">
              <div v-for="task in filteredTasks" :key="task.id" class="task-card mb-3 p-3 d-flex align-items-center">
                <div class="date-badge mr-3 text-center" :style="{ color: task.color, border: '1px solid ' + task.color }" @click="openEventModal(task)">
                  <div class="fw-bold day-text">{{ formatDay(task.start) }}</div>
                  <div class="month-text">{{ formatMonthShort(task.start) }}</div>
                  <div class="month-text">{{ task.time }}</div>
                </div>

                <div class="flex-grow-1 cursor-pointer" @click="openEventModal(task)">
                  <h6 class="mb-0 fw-bold title-text twoLineOnly">{{ task.title }}</h6>
                  <p v-if="task.description" class="font-size-12 mb-1 text-muted twoLineOnly">{{ task.description }}</p>
                  <a @click="goToMeeting(task.raw.calendar_meeting_link)" class="font-size-12 mb-0 fw-bold twoLineOnly cursor-pointer primary-color text-muted">Join Meeting</a>
                </div>

                <div v-if="userData.user_role === 'USERROLE11118' || userData.user_role === 'USERROLE11111'" class="d-flex flex-column gap-1">
                  <button class="btn p-1 text-primary btn-sm" @click.stop="openEventModal(task)">
                    <i class="fa fa-eye" />
                  </button>
                  <button class="btn p-1 text-primary" @click.stop="openEventModal(task, 'edit')">
                    <i class="fa fa-pen" />
                  </button>
                  <b-button variant="btn btn actionIcon font-size-20 mb-1 btn-secondary btn-sm" @click="showSpcmCalenderDeleteDialog(task)" size="sm">
                    <i class="ri-delete-bin-line font-size-20 primary-color m-0"></i>
                  </b-button>
                </div>
              </div>
            </div>
            <div v-else class="text-center py-4">
              <p class="text-muted small mb-0">No events for this date.</p>
            </div>
          </div>
          <hr/>
          <div class="card border-0 shadow-sm rounded-lg monthly-scroll-card">
          <div class="card-header bg-white border-0 p-4 pb-0">
            <h5 class="fw-bold mb-0">Monthly Overview</h5>
            <p class="text-muted small mb-0 fw-semibold">{{ currentMonthName }} {{ viewYear }}</p>
          </div>
          <div class="card-body px-4 pt-3">
            <div v-if="tasksForSelectedMonth.length > 0" class="task-list">
              <div v-for="task in tasksForSelectedMonth" :key="'month-'+task.id" class="task-card mb-3 p-3 d-flex align-items-center">
                <div class="date-badge mr-3 text-center" :style="{ color: task.color, border: '1px solid ' + task.color }">
                  <div class="fw-bold day-text">{{ formatDay(task.start) }}</div>
                  <div class="month-text">{{ formatMonthShort(task.start) }}</div>
                  <div class="month-text">{{ task.time }}</div>
                </div>
                <div class="flex-grow-1">
                  <h6 class="mb-0 fw-bold title-text twoLineOnly">{{ task.title }}</h6>
                  <p class="text-muted small p-0 m-0 twoLineOnly">{{ task.description }}</p>
                  <p class="text-muted small p-0 m-0">{{ task.category }}</p>
                </div>
                <div class="d-flex flex-column gap-1">
                    <button class="btn p-1 text-primary btn-sm" @click.stop="openEventModal(task)">
                      <i class="fa fa-eye" />
                    </button>
                  <button class="btn pull-right text-primary" @click="openEventModal(task, 'edit')"  v-if="userData.user_role == 'USERROLE11118' || userData.user_role === 'USERROLE11111'"><i class="fa fa-pen" /></button>
                  <b-button variant="btn btn actionIcon font-size-20 mb-1 btn-secondary btn-sm" @click="showSpcmCalenderDeleteDialog(task)" size="sm"  v-if="userData.user_role == 'USERROLE11118' || userData.user_role === 'USERROLE11111'">
                    <i class="ri-delete-bin-line font-size-20 primary-color m-0"></i>
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>
    </div>

    <b-modal v-model="showModal" hide-footer centered title="Event Details" header-class="border-0 pb-0" body-class="pt-2">
      <div v-if="selectedTask">
        <div class="d-flex align-items-center mb-3">
          <div class="p-2 rounded w-100" :style="{ backgroundColor: selectedTask.color + '22', borderLeft: '5px solid ' + selectedTask.color }">
            <h4 class="mb-0 fw-bold" :style="{ color: selectedTask.color }">{{ selectedTask.title }}</h4>
          </div>
        </div>

        <div class="mb-3">
          <label class="text-muted small fw-bold mb-1">DATE & TIME</label>
          <p class="mb-0"><i class="fa fa-calendar mr-2 text-primary"></i> {{ formatFullDate(selectedTask.start) }}</p>
          <p class="mb-0"><i class="fa fa-clock-o mr-2 text-primary"></i> {{ selectedTask.time || 'All Day' }}</p>
        </div>
        <div v-if="selectedTask.category" class="mb-3">
          <p class="bg-light p-3 rounded text-dark font-weight-bolder">{{ selectedTask.category }}</p>
        </div>
        <div v-if="selectedTask.description" class="mb-3">
          <label class="text-muted small fw-bold mb-1">DESCRIPTION</label>
          <p class="bg-light p-3 rounded text-dark">{{ selectedTask.description }}</p>
        </div>

        <div class="text-right mt-4">
          <b-button variant="light" @click="showModal = false">Close</b-button>
        </div>
      </div>
    </b-modal>

    <b-modal
      v-model="showModelSpcmCalenderEdit"
      scrollable
      :title="cvEditModalHeader"
      size="lg"
    >
      <SpcmCalenderEdit
        v-if="selectedTask"
        :propOpenedInModal="true"
        :propActivity="true"
        :propSpcmCalenderObj="selectedTask.raw"
        @emitCloseSpcmCalenderEditModal="closeSpcmCalenderEditModal"
      />
      <template #modal-footer="">
        <b-button size="sm" @click="closeSpcmCalenderEditModal()">
          {{cvbtnModalCancel}}
        </b-button>
      </template>
    </b-modal>

    <b-modal v-model="showModelSpcmCalenderAdd" scrollable :title="cvAddModalHeader" size="lg">
      <SpcmCalenderAddV1 :propOpenedInModal="true" :propSpcmId=propSpcmObj.spcm_id :propUserId="propStudentData ? propStudentData.user_id : null" :propActivity="true" @emitCloseSpcmCalenderAddModal="closeSpcmCalenderAddModal"/>
      <template #modal-footer="">
        <b-button size="sm" @click="closeSpcmCalenderAddModal()">{{cvbtnModalCancel}}</b-button>
      </template>
    </b-modal>

    <b-modal v-model="showModelSpcmCalenderDelete" size="lg" title="Delete" ok-title="Delete" cancel-title="Cancel">
      <p>{{cvDelMessage}}</p>
      <template #modal-footer="">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="sm" @click="showModelSpcmCalenderDelete = false">
          {{cvbtnModalCancel}}
        </b-button>
        <b-button size="sm" variant="primary" @click="spcmCalendarDelete()">
          {{cvbtnModalDelOk}}
        </b-button>
      </template>
    </b-modal>

     <b-toast v-model="showToast" name="Toast" :variant="toastVariant" :title="toastTitle">
      <div v-html="toastMsg"></div>
    </b-toast>
  </div>
</template>

<script>
import moment from "moment"
import FullCalendarWrapper from "./FullCalendar.vue"
import { SpcmCalenders } from "../FackApi/api/SpcmCalender.js"
import SpcmCalenderAddV1 from "../../src/views/Gide/SPCM/SpcmCalenderAddV1.vue"
import SpcmCalenderEdit from "../../src/views/Gide/SPCM/SpcmCalenderEditV1.vue"
import { SpcmCalendarCategorys } from "../FackApi/api/SpcmCalendarCategory.js"
import ApiResponse from "../Utils/apiResponse.js"

export default {
  name: "CalendarDashboard",
  components: {
    FullCalendarWrapper,
    SpcmCalenderAddV1,
    SpcmCalenderEdit
  },
  props: {
    propStudentData: { default: null },
    propSpcmObj: { default: null }
  },
  data () {
    return {
      selectedDate: moment().format("YYYY-MM-DD"),
      viewMonth: moment().format("MM"),
      viewYear: moment().format("YYYY"),
      selectedCategory: null,
      allEvents: [],
      showToast: false,
      toastMsg: null,
      spcmCalendarCategory: [],
      months: [
        { "value": "01", "text": "January" }, { "value": "02", "text": "February" },
        { "value": "03", "text": "March" }, { "value": "04", "text": "April" },
        { "value": "05", "text": "May" }, { "value": "06", "text": "June" },
        { "value": "07", "text": "July" }, { "value": "08", "text": "August" },
        { "value": "09", "text": "September" }, { "value": "10", "text": "October" },
        { "value": "11", "text": "November" }, { "value": "12", "text": "December" }
      ],
      years: ["2025", "2026", "2027", "2028"].map(y => ({ value: y, text: y })),
      showModal: false,
      selectedTask: null,
      showModelSpcmCalenderAdd: false,
      cvbtnModalCancel: "Close",
      cvAddModalHeader: "Add New Appointment",
      whereFilter: { counsellor_id: null, user_id: null },
      showModelSpcmCalenderEdit: false,
      cvEditModalHeader: "Edit Appointment",
      toastTitle: "Delete",
      showModelSpcmCalenderDelete: false,
      delObj: null,
      cvbtnModalDelOk: "Delete",
      cvDelMessage: "Are you sure?",
      toastVariant: "default"
    }
  },
  computed: {
    userData () {
      return { ...this.$store.getters["User/userData"] }
    },
    filteredCalendarEvents () {
      if (!this.selectedCategory) return this.allEvents
      return this.allEvents.filter(e => e.category === this.selectedCategory)
    },
    filteredTasks () {
      let tasks = this.allEvents.filter(e => e.start === this.selectedDate)
      if (this.selectedCategory) {
        tasks = tasks.filter(e => e.category === this.selectedCategory)
      }
      return tasks
    },
    tasksForSelectedMonth () {
      const monthPrefix = `${this.viewYear}-${this.viewMonth}`
      let tasks = this.allEvents.filter(e => e.start.startsWith(monthPrefix))
      if (this.selectedCategory) {
        tasks = tasks.filter(e => e.category === this.selectedCategory)
      }
      return tasks.sort((a, b) => moment(a.start).unix() - moment(b.start).unix())
    },
    currentMonthName () {
      const monthObj = this.months.find(m => m.value === this.viewMonth)
      return monthObj ? monthObj.text : ""
    },
    isTodaySelected () { return this.selectedDate === moment().format("YYYY-MM-DD") },
    displayDateLabel () { return moment(this.selectedDate).format("dddd, MMM Do, YYYY") }
  },
  async mounted () {
    await this.SpcmCalendarCategoryList()
    await this.spcmCalendarConsoleList()
  },

  methods: {
    /**
     * Go To Meeting Link
     */
    goToMeeting (url) {
      window.open(url, "_blank")
    },
    /**
     * Fetch calendar list from API and format events for calendar display
     */
    async spcmCalendarConsoleList () {
      try {
        if (this.userData?.user_role === "USERROLE11114") {
          this.whereFilter.user_role = "USERROLE11114"
        }
        else if (this.userData?.user_role === "USERROLE11118") {
          this.whereFilter.counsellor_id = this.userData.user_id
        }
        else if (this.propSpcmObj?.counsellor_id) {
          this.whereFilter.counsellor_id = this.propSpcmObj.counsellor_id
        }

        if (this.propSpcmObj?.user_id) {
          this.whereFilter.user_id = this.propSpcmObj.user_id
        }
        if (this.userData.user_role) {
          this.whereFilter.user_id = this.propSpcmObj.user_id
        }

        let resp = await SpcmCalenders.spcmCalendarConsoleList(this, this.whereFilter)

        if (resp.resp_status) {
          const apiData = resp.resp_data.data
          const formattedEvents = []

          for (const item of apiData) {
            const startMoment = moment.unix(item.slot_start_ts)
            const themeColor = this.getCategoryColor(item.category)

            formattedEvents.push({
              id: item.spcm_calendar_id,
              title: item.title,
              category: item.category,
              description: item.description,
              start: startMoment.format("YYYY-MM-DD"),
              time: startMoment.format("hh:mm A"),
              backgroundColor: themeColor,
              borderColor: themeColor,
              textColor: "#ffffff",
              display: "block",
              color: themeColor,
              calendar_hosting_platform: item.calendar_hosting_platform,
              calendar_meeting_link: item.calendar_meeting_link,
              raw: item
            })
          }

          this.allEvents = formattedEvents
        }
      }
      catch (err) {
        console.error("API Error:", err)
      }
    },

    /**
     * SpcmCalendarCategory List
     */
    async SpcmCalendarCategoryList () {
      try {
        let SpcmCalendarCategoryListResp = await SpcmCalendarCategorys.SpcmCalendarCategoryList(this)
        if (SpcmCalendarCategoryListResp.resp_status) {
          this.spcmCalendarCategory = SpcmCalendarCategoryListResp.resp_data.data
          this.showLoadMoreBtn = true
        }
        else {
          this.toastMsg = SpcmCalendarCategoryListResp.resp_msg
          this.toastVariant = "danger"
          this.showToast = true
        }
      }
      catch (err) {
        console.error("Exception occurred at SpcmCalendarCategoryList() and Exception:", err)
      }
    },
    /**
     * Return theme color based on category name
     * @param {String} category
     * @returns {String} Hex color code
     */
    getCategoryColor (category) {
      const cat = category ? category.toLowerCase() : ""

      const colors = {
        "strategy & planning": "#ff4d4f",
        "introduction meeting": "#ff4d4f",
        "meetings": "#50b5ff",
        "application": "#a657ff",
        "sat test/planning": "#ff4d4f",
        "internships": "#2ecc71",
        "sop": "#e84393",
        "essay": "#f39c12"
      }
      return colors[cat] || "#00cec9"
    },

    /**
     * Handle calendar date selection change
     * @param {String} dateStr
     */
    handleDateChange (dateStr) {
      this.selectedDate = dateStr
    },

    /**
     * Update calendar view when month or year changes
     */
    updateCalendarView () {
      this.$nextTick(() => {
        const date = `${this.viewYear}-${this.viewMonth}-01`
        if (this.$refs.calendarRef) {
          this.$refs.calendarRef.gotoDate(date)
        }
      })
    },

    /**
     * Reset calendar view to today's date and clear filters
     */
    resetToToday () {
      this.selectedDate = moment().format("YYYY-MM-DD")
      this.viewMonth = moment().format("MM")
      this.viewYear = moment().format("YYYY")
      this.selectedCategory = null
      this.updateCalendarView()
    },

    /**
     * Format day from date
     * @param {String|Date} date
     * @returns {String}
     */
    formatDay (date) {
      return moment(date).format("DD")
    },

    /**
     * Format short month name from date
     * @param {String|Date} date
     * @returns {String}
     */
    formatMonthShort (date) {
      return moment(date).format("MMM")
    },

    /**
     * Format full readable date
     * @param {String|Date} date
     * @returns {String}
     */
    formatFullDate (date) {
      return moment(date).format("MMMM Do, YYYY")
    },
    /**
     * Modified: Open event details OR edit modal
     */
    openEventModal (task, mode = "view") {
      this.selectedTask = task

      if (mode === "edit") {
        this.showModelSpcmCalenderEdit = true
      }
      else {
        this.showModal = true
      }
    },
    /**
     * Open add calendar appointment modal
     */
    addCalendarAppointment () {
      this.showModelSpcmCalenderAdd = true
    },

    /**
     * Close add calendar modal and refresh list
     */
    closeSpcmCalenderAddModal () {
      this.showModelSpcmCalenderAdd = false
      this.spcmCalendarConsoleList()
    },
    /**
     * Close edit modal and refresh
     */
    closeSpcmCalenderEditModal () {
      this.showModelSpcmCalenderEdit = false
      this.selectedTask = null
      this.spcmCalendarConsoleList() // Refresh data after edit
    },
    /**
     * spcmCalendarDelete
     */
    async spcmCalendarDelete () {
      try {
        if (!this.delObj || !this.delObj.id) return

        let spcmCalendarDelResp = await SpcmCalenders.spcmCalendarDelete(this, this.delObj.id)
        await ApiResponse.responseMessageDisplay(this, spcmCalendarDelResp)

        if (spcmCalendarDelResp && spcmCalendarDelResp.resp_status) {
          this.showModelSpcmCalenderDelete = false
          this.delObj = null
          this.toastMsg = "Successfully delete"
          this.toastVariant = "success"
          this.showToast = true
          await this.spcmCalendarConsoleList()
        }
        else {
          this.showModelSpcmCalenderDelete = false
        }
      }
      catch (err) {
        console.error("Exception occurred at spcmCalendarDelete() and Exception:", err.message)
        this.showModelSpcmCalenderDelete = false
      }
    },
    /**
     * showSpcmCalenderDeleteDialog
     */
    showSpcmCalenderDeleteDialog (item) {
      try {
        this.delObj = item
        this.showModelSpcmCalenderDelete = true
      }
      catch (err) {
        console.error("Exception occurred at showSpcmCalenderDeleteDialog() and Exception:", err.message)
      }
    }
  }
}
</script>

<style scoped>
.task-card {
  background: #fff;
  border: 1px solid #eee;
  border-radius: 8px;
  padding: 16px 16px 16px 20px;
  position: relative;
  transition: all 0.3s ease;
  cursor: pointer;
}
.task-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  border-color: #ddd;
}
.task-indicator {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 5px;
  border-radius: 8px 0 0 8px;
}
.date-badge {
  min-width: 65px;
  padding: 5px;
  border-radius: 8px;
  line-height: 1.2;
  cursor: pointer;
}
.day-text { font-size: 1.1rem; }
.month-text { font-size: 0.7rem; text-transform: uppercase; }
.task-card {
  background: #f8f9fa; /* Or white */
  border-radius: 10px;
  transition: transform 0.2s;
}
.cursor-pointer { cursor: pointer; }
.twoLineOnly {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  line-height: 1.2em;
  max-height: 3.4em;
  word-break: break-word;
  min-height: unset;
}
</style>
